export const SET_VIEW_MODE = 'SET_VIEW_MODE';
export const SET_HAS_TOUCH_SCREEN = 'SET_HAS_TOUCH_SCREEN';
export const SET_VIDEO_VISIBILITY = 'SET_VIDEO_VISIBILITY';
export const TOGGLE_UNREAD_BETS_NOTIFICATION = 'TOGGLE_UNREAD_BETS_NOTIFICATION';
export const SET_VIDEO_MUTED = 'SET_VIDEO_MUTED';
export const SET_SHOW_VIRTUAL_KEYBOARD = 'SET_SHOW_VIRTUAL_KEYBOARD';
export const SET_FULL_VIEW_PLAYER = 'SET_FULL_VIEW_PLAYER';

export const CREATE_GAMES = 'CREATE_GAMES';
export const CREATE_DISABLED_GAMES = 'CREATE_DISABLED_GAMES';
export const SELECT_GAME = 'SELECT_GAME';
export const ENABLE_DISABLE_GAME = 'ENABLE_DISABLE_GAME';
export const SET_GAME_CONTROLLER_STATE = 'SET_GAME_CONTROLLER_STATE';
export const SET_PROMO_BALANCE_WEB = 'SET_PROMO_BALANCE_WEB';
export const UPDATE_ON_LOAD = 'UPDATE_ON_LOAD';

export const SET_EVENTS = 'SET_EVENTS';
export const SELECT_EVENT = 'SELECT_EVENT';
export const SET_NEXT_EVENTS_TIMESTAMP = 'SET_NEXT_EVENTS_TIMESTAMP';
export const SET_NO_MORE_BETS_EVENT = 'SET_NO_MORE_BETS_EVENT';
export const SET_RESULT = 'SET_RESULT';
export const SET_RESULT_COUNTER = 'SET_RESULT_COUNTER';
export const REMOVE_NO_MORE_BETS_EVENT = 'REMOVE_NO_MORE_BETS_EVENT';
export const CLEAR_EVENT_OPEN_BETS = 'CLEAR_EVENT_OPEN_BETS';
export const SET_EVENT_LAST_RESULTS = 'SET_EVENT_LAST_RESULTS';
export const SET_BET_SLIP_VIEW = 'SET_BET_SLIP_VIEW';
export const SET_MATCHDAY_UPDATE = 'SET_MATCHDAY_UPDATE';

//Bet Slip Modal
export const OPEN_CLOSE_BET_SLIP_MODAL = 'OPEN_CLOSE_BET_SLIP_MODAL';
export const CHANGE_BET_SLIP_MODAL_SELECTED_SCREEN = 'CHANGE_BET_SLIP_MODAL_SELECTED_SCREEN';

export const OPEN_CLOSE_MODAL = 'OPEN_CLOSE_MODAL';

export const OPEN_CLOSE_HELP_PAGES = 'OPEN_CLOSE_HELP_PAGES';
export const OPEN_CLOSE_SETTINGS = 'OPEN_CLOSE_SETTINGS';

export const OPEN_CLOSE_ACCUMULATOR_BOOST = 'OPEN_CLOSE_ACCUMULATOR_BOOST';
export const OPEN_CLOSE_REALITY_CHECK_MODAL = 'OPEN_CLOSE_REALITY_CHECK_MODAL';
export const OPEN_CLOSE_DEMOPLAY_CHECK_MODAL = 'OPEN_CLOSE_DEMOPLAY_CHECK_MODAL';
export const OPEN_CLOSE_MYOFFERS_LIST_MODAL = 'OPEN_CLOSE_MYOFFERS_LIST_MODAL';
export const OPEN_CLOSE_GIFT_FOR_YOU_MODAL = 'OPEN_CLOSE_GIFT_FOR_YOU_MODAL';
export const OPEN_CLOSE_TERMS_AND_CONDITIONS_MODAL = 'OPEN_CLOSE_TERMS_AND_CONDITIONS_MODAL';
export const OPEN_CLOSE_MYOFFERS_MODAL = 'OPEN_CLOSE_MYOFFERS_MODAL';
//Odds type
export const CHANGE_ODDS_TYPE = 'CHANGE_ODDS_TYPE';
export const CHANGE_SYSTEM_LANGUAGE = 'CHANGE_SYSTEM_LANGUAGE';

export const SELECT_CHIP = 'SELECT_CHIP';

// platform actions
export const HANDLE_GET_STATE_RESPONSE = 'HANDLE_GET_STATE_RESPONSE';
export const SET_SERVER_TIME_OFFSET = 'SET_SERVER_TIME_OFFSET';
export const SET_LOADING_BAR = 'SET_LOADING_BAR';
export const UPDATE_PLAYER_BALANCE = 'UPDATE_PLAYER_BALANCE';
export const SET_SERVER_TIME_ZONE_OFFSET = 'SET_SERVER_TIME_ZONE_OFFSET';

//bet slip actions
export const COLLAPSE_OPEN_BET_ACCORDION = 'COLLAPSE_OPEN_BET_ACCORDION';
export const COLLAPSE_PLACED_BET_ACCORDION = 'COLLAPSE_PLACED_BET_ACCORDION';
export const COLLAPSE_SETTLED_BET_ACCORDION = 'COLLAPSE_SETTLED_BET_ACCORDION';

//event index of an event under a matchday
export const SET_SELECTED_MATCHDAY_SUB_EVENT_INDEX = 'SET_SELECTED_MATCHDAY_SUB_EVENT_INDEX';
export const SET_EVENT_TAB_CLICK_STATUS = 'SET_EVENT_TAB_CLICK_STATUS';
export const SET_SELECTED_MATCHDAY_EVENT_ID = 'SET_SELECTED_MATCHDAY_EVENT_ID';

export const SELECT_PROMO_BET = 'SELECT_PROMO_BET';
export const SELECT_TC_PROMO_ID = 'SELECT_TC_PROMO_ID';
export const DO_NOT_SHOW_CHECK = 'DO_NOT_SHOW_CHECK'


// WEBPACK FOOTER //
// ./src/constants/actionTypes.js